import { Component } from '@angular/core';
import { ScreenType } from '@fgb/core';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-quiz-layout-page',
  templateUrl: './quiz-layout-page.component.html',
  styleUrl: './quiz-layout-page.component.scss',
})
export class QuizLayoutPageComponent {
  productCode = ProductCode;
  screenType = ScreenType;
}
